import React, {Component}   from 'react';
import {
	Grid,
	Row,
	Col,
	Button,
	Collapse,
	Glyphicon
}                           from 'react-bootstrap';

import bg                   from '../../assets/image/rwmbg_cmslogin.jpg';
import ic_mobile            from '../../assets/image/icn_rwmmobile.png';
import logo                 from '../../assets/image/newport-world-resorts.png';
import ic_notification      from '../../assets/image/ic_notification.svg';
import ic_history           from '../../assets/image/ic_history.svg';
import ic_logout            from '../../assets/image/ic_logout.svg';
import ic_logout_white      from '../../assets/image/ic_logout_white.svg';
import ic_arrowdown         from '../../assets/image/ic_arrowdown.svg';

import style                from './style.less';
import sidebar              from './sidebar.less';

import {
	Route,
	Link,
	Switch
}                           from 'react-router-dom'

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';

import {
	NAVIGATION,
	ACCESS_RIGHT,
	NOTIFICATION_SET_VALUE
}                           from 'actions/const';

import Modal                from './Modal';

import routes               from './routeV2.js';

import Profile              from '../profile';
import PageNotFound         from '../PageNotFound';
import AccessDenied         from '../AccessDenied';
import
ServerProcessMonitoring     from '../ServerProcessMonitoring';


class Navigation extends Component {
	constructor(props) {
		super(props)

		this.state = {
			open1: false,
			openMenu: false
		};

		this.logout = this.logout.bind(this);
		// this.showModal = this.showModal.bind(this);
	}

	componentDidMount() {
		let {setValue} = this.props.actions;

		this.getAccessRight();

		var query = new Parse.Query('CardType');
		query.ascending("name");
		query.limit(20);

		var query2 = new Parse.Query('Screen');
		query2.ascending("pageName");
		query2.limit(20);

		Promise.all([query.find(), query2.find()]).then((datas) => {
			console.log(datas)

			var screens = datas[1].map((item) => {
				item = {
					value: item.id,
					label: item.get('pageName')
				}
				return item;
			})

			var cardTypes = datas[0].map((item) => {
				item = {
					value: item.id,
					label: item.get('name')
				}
				return item;
			})

			setValue(NOTIFICATION_SET_VALUE, 'cardTypeOptions', cardTypes)
			setValue(NOTIFICATION_SET_VALUE, 'screenOptions', screens)
		}).catch((err) => {
			console.log(err);
			if (err.code === Parse.Error.INVALID_SESSION_TOKEN) {
				this.logout();
				// console.log('Logged out');
				// Parse.User.logOut();
				// localStorage.clear();
				// let {history} = this.props;
				// history.push('/login');
			}
		})

	}

	componentWillMount() {
		var appStyle = document.getElementById('app-body').style;
		var bodyStyle = document.body.style;

		appStyle.height = '100%';
		bodyStyle.height = '100%';
		bodyStyle.backgroundImage = 'url("' + bg + '")';
		bodyStyle.backgroundSize = '100% 100%';
		bodyStyle.backgroundRepeat = 'no-repeat';

		let {setValue} = this.props.actions
		setValue(NAVIGATION, 'showModal', false)

		console.log('componentWillMount', this.props.navigation)

		let {history} = this.props;

		Parse.Session.current()
		.then((data) => {
			// session if valid
			console.log("VALID: ", data);
		})
		.catch((err) => {
			console.log("ERROR: ", err);
			if (err === 'There is no current user.' || err.code === Parse.Error.INVALID_SESSION_TOKEN) {
				this.logout();
				// console.log('Logged out');
				// Parse.User.logOut();
				// localStorage.clear();
				// history.push('/login');
			}
		});
	}

	// REMOVE BACKGROUND WHEN UNMOUNTING
	// componentWillUnmount() {
	// 	var appStyle = document.getElementById('app-body').style;
	// 	var bodyStyle = document.body.style;
	//
	// 	appStyle.height = null;
	// 	bodyStyle.height = null;
	// 	bodyStyle.backgroundImage = null;
	// 	bodyStyle.backgroundSize = null;
	// 	bodyStyle.backgroundRepeat = null;
	// }

	logout() {
		let {history} = this.props
		let {setValue} = this.props.actions;

		setValue(NAVIGATION, 'isLoggingOut', true);

		Parse.User.logOut()
		.then((data) => {
			console.log('Logged out');
			localStorage.clear();
			setValue(NAVIGATION, 'isLoggingOut', false);
			history.push('/login');
		})
		.catch((err) => {
			if (err.code === Parse.Error.INVALID_SESSION_TOKEN) {
				this.logout();
			}
			setValue(NAVIGATION, 'isLoggingOut', false);
		});
	}

	renderSidebar(data, index) {
		if (data.groupName) {
			let showMenu = () => {
				let displayArray = data.routes.map((submenu) => this.accessible(submenu.link));

				let test = (display) => {
					return display === 'none';
				}

				if (displayArray.every(test)) {
					return 'none';
				} else {
					return '';
				}
			};

			return (
				<div
					style={{ display: showMenu() }}
					onClick={() => this.setState({
						[`open${index}`]: !this.state[`open${index}`]
					})}
					>
					<div className={sidebar.sampleHover}
						style={{
							paddingLeft: '20px',
							paddingTop: '13px',
							paddingBottom: '13px'
						}}>
						<li style={{
							fontWeight: "900"
						}}>
							<img src={data.icon} style={{
								width: "20px",
								marginRight: "30px"
							}}/>
							{data.groupName}
							<img src={ic_arrowdown} style={{
								width: "10px",
								marginLeft: "55px"
							}}/>
						</li>
					</div>
					<Collapse in={this.state[`open${index}`] || false}>
						<div>
							{
								data.routes.map((submenu, index2) =>
									<li
										className={sidebar.sampleHover}
										style={{
											fontWeight: "900",
											display: this.accessible(submenu.link)
										}}
										>
										<Link to={submenu.link}
											style={{
												width: '100%',
												height: '100%',
												paddingLeft: '80px'
											}}
											onClick={() => {
												if (this.state.openMenu) {
													this.setState({
														openMenu: false
													});
												}
											}}
											>
											{submenu.name}
										</Link>
									</li>
								)
							}
						</div>
					</Collapse>
				</div>
			);
		} else {
			return (
				<Link to={data.link} style={{ padding: '0' }}
					onClick={() => {
						if (this.state.openMenu) {
							this.setState({
								openMenu: false
							});
						}
					}} 
				>
					<li
						className={sidebar.sampleHover}
						style={{
							fontWeight: "900",
							display: this.accessible(data.link)
						}}
						>
						<img src={data.icon} style={{
							width: "20px",
							marginRight: "30px"
						}}/>
						{data.name}
					</li>
				</Link>

			);
			// <li
			// 	className={sidebar.sampleHover}
			// 	style={{
			// 		fontWeight: "900",
			// 		display: this.accessible(data.link)
			// 	}}
			// 	>
			// 	<Link to={data.link} style={{ width: '100%', height: '100%'}}>
			// 		<img src={data.icon} style={{
			// 			width: "20px",
			// 			marginRight: "30px"
			// 		}}/>
			// 		{data.name}
			// 	</Link>
			// </li>
		}
	}

	getAccessRight() {
		let {setValue} = this.props.actions;

    let json = [];
    let rights = localStorage.rights;
    if (typeof rights !== 'undefined') {
      json = JSON.parse(rights);

      var access = [];
			for (var module of json) {
				var actions = [];
				for(var action of module.actions) {
	        actions.push(action.name.toUpperCase());
	      }
				access.push({route: module.route, actions: actions});
			}

      setValue(ACCESS_RIGHT, 'access', access);
    }
  }

	accessible(Route) {
		let {
			access
		} = this.props.accessjson;

		if (access.length !== 0) {
			var currentPath = Route,
					index = access.map((module) => module.route.toUpperCase()).indexOf(currentPath.toUpperCase()),
					actions = [];

			if (index != -1) {
				return '';
			} else {
	      return 'none';
	    }
		} else {
			return 'none';
		}
	}

	render() {
		let {setValue} = this.props.actions;
		let {isLoggingOut} = this.props.navigation;

		var isDisabled = (isLoggingOut) ? 'true' : '';

		return (
			<Grid className={[style.fullWidth, style.fullHeight].join(' ')} style={{
				margin: '0px',
				padding: '0px',
				overflow: 'auto'
			}}>
				<Row className={style.fullWidth} style={{
					padding: '0px',
					margin: '0px',
					height: '15%'
				}}>
					<Col md={2} className={style.fullHeight}
						sm={2}
						xs={3}
						style={{
							backgroundColor: '#D1282F',
						}}>
						<img src={ic_mobile} style={{
							display: 'block',
							margin: '0 auto',
							padding: '20px 0',
							height: "100%"
						}}/>
					</Col>
					<Col md={10} className={ [style.fullHeight, style.headerContainer].join(" ") }
						sm={10}
						xs={9}
						// style={{
						// 	backgroundColor: 'white',
						// 	padding: "",
						// 	boxShadow: '0 10px 10px -2px rgba(0, 0, 0, 0.19)'
						// }}
						>
						<img className="rwmLogo" src={logo} style={{ height: "100%" }}/>
						<div className={['iconHeadWrapper', style.iconHeadWrapper].join(' ')}>
							{/* <img className={[style.iconHead, 'iconHead'].join(' ')}
								src={ic_notification}
								style={{cursor: 'pointer'}}/>
							<img className={[style.iconHead, 'iconHead'].join(' ')}
								src={ic_history}
								style={{cursor: 'pointer'}}/> */}
							<img className={[style.iconHead, 'iconHead', style.iconLogOut].join(' ')}
								src={ic_logout}
								style={{cursor: 'pointer'}}
								onClick={() => setValue(NAVIGATION, 'showModal', true)}/>
							<Button
								className={style.menuButton}
								onClick={() => {
									this.setState({
										openMenu: !this.state.openMenu
									});
								}}
							>
								<i className="fa fa-bars fa-lg"/>
							</Button>
						</div>
					</Col>
				</Row>
				<Row className={[style.fullWidth].join(' ')} style={{
					padding: '0px',
					margin: '0px',
					height: '85%'
				}}>
					<Collapse in={this.state.openMenu} className={style.collapseMenu}>
						<Col md={2}
							className={[style.fullHeight].join(' ')}
							style={{
								padding: '0',
								backgroundColor: 'black'
							}}>
							<div className={sidebar.sidebarContainer}>
								<ul className={sidebar.navlinks}>
									<a style={{ padding: '0' }}>
										<li
											className={sidebar.sampleHover}
											style={{
												fontWeight: "900"
											}}
											onClick={() => setValue(NAVIGATION, 'showModal', true)}
										>
											<img src={ic_logout_white} style={{
												width: "20px",
												marginRight: "30px"
											}}/>
											LOG OUT
										</li>
									</a>
									{
										routes.map(this.renderSidebar.bind(this))
									}
								</ul>
							</div>
						</Col>
					</Collapse>
					<Col md={2}
						className={[style.menu, style.fullHeight].join(' ')}
						style={{
							padding: '0',
							backgroundColor: 'black'
						}}>
						<div className={sidebar.sidebarContainer}>
							<ul className={sidebar.navlinks}>
								{
									routes.map(this.renderSidebar.bind(this))
								}
							</ul>
						</div>
					</Col>
					{/*
						<Col md={2} className={['sideBar', style.fullHeight].join(' ')} style={{
							backgroundColor: 'black',
							padding: '0'
						}}>
							<ul className={[style.navUl, style.fullWidth].join(' ')}>
								{
									routes.map((data, index) =>
										<li
											key={index}
											className={[style.linkStyle, style.fullWidth, style.linkBorder].join(' ')}
											style={{ display: this.accessible(data.link) }}
											>
											<Link to={data.link} className={style.linkStyle} style={{
												padding: '20px 0 0 30px',
												textDecoration: 'none'
											}}>
												<img className={style.navIcon} src={data.icon} height="26px"/>
												<span className={style.navIconText}>
													<h4 style={{
														display: 'inline'
													}}>{data.name}</h4>
												</span>
											</Link>
										</li>
									)
								}
							</ul>
						</Col>
						*/}
					<Col md={10} style={{
						height: '100%',
						margin: '0',
						padding: '2% 5% 2% 5%',
						overflow: 'auto'
					}}>
					<Switch>
						{
							routes.map((data, index) => {
								if (data.groupName) {
									return data.routes.map((data2, index2) =>
										<Route key={index2} exact path={`${this.props.match.url+data2.link.slice(1)}`} component={ this.accessible(data2.link) === '' ? data2.component : AccessDenied }/>
									);
								} else {
									return <Route key={index} exact={typeof data.exact === "undefined" ? true : data.exact} path={`${this.props.match.url+data.link.slice(1)}`} component={ this.accessible(data.link) === '' ? data.component : AccessDenied }/>
								}
							})
						}
						<Route exact path={`${this.props.match.url}profile`} component={Profile}/>
						<Route exact path={`${this.props.match.url}app-server-process-monitoring`} component={ServerProcessMonitoring}/>
						<Route exact path="*" component={PageNotFound} />
					</Switch>
					</Col>
				</Row>
				<Modal>
					<div>
						Resorts World Manila
					</div>
					<p>Are you sure you want to logout?</p>
					<div>
						<Button
							onClick={() => setValue(NAVIGATION, 'showModal', false)}
							disabled={isDisabled}
							>
							No
						</Button>
						<Button className="btn btn-primary"
							onClick={this.logout}
							disabled={isDisabled}
							>
							{(isLoggingOut) ?
								<i className="fa fa-spinner fa-spin" style={{color: 'white'}}></i>
								: ''
							}
							&nbsp;Yes
						</Button>
					</div>
				</Modal>
			</Grid>
		);
	}
}

function mapStateToProps(state) {
	var {navigation, accessjson} = state;
	const props = {
		navigation,
		accessjson
	};
	return props;
}

function mapDispatchToProps(dispatch) {
	const actions = {
		setValue: generics.setValue
	};
	const actionMap = {
		actions: bindActionCreators(actions, dispatch)
	};
	return actionMap;
}

export default connect(mapStateToProps, mapDispatchToProps)(Navigation);



// WEBPACK FOOTER //
// ./components/Navigation/index.js